import * as angular from "angular";
import {IController} from "angular";
import {RoutesService} from "../../../routes/services/routes-service.service";

export class planningRouteTimelineLogsViewCtrl implements IController {

  routeId: any;
  limit: number;

  private timeline;

  constructor(private routesService: RoutesService) {
  }

  $onInit() {
    if(!this.limit) {
      this.limit = 100;
    }
    this._getLogsTimeline();
  }

  $onChanges(changes) {
    if (changes.route && !changes.route.isFirstChange()) {
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.routeId) {
      this.routesService.getLogsTimeline(this.routeId, this.limit)
        .then((timeline) => {
          this.timeline = timeline;
        })
    }
  }

}
angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTimelineLogsView', {
    bindings: {
      routeId: '<',
      limit: '<?'
    },
    template: require('./planning-route-timeline-logs-view.html').default,
    controller: planningRouteTimelineLogsViewCtrl
  });
